import { TCreateSolutionAPIResponse } from "@/types/solutions.types";

/**
 * The create-solution endpoint (`POST /interviews/{slug}/solutions/`) returns
 * one of two shapes: `{ solution_slug }` or the full solution object that
 * carries `slug`. Read whichever is present so callers always get the slug.
 *
 * Returns `undefined` only when neither field is present, which callers must
 * treat as a failed create (e.g. skip the dependent attachment upload).
 */
const getSolutionSlugFromCreateResponse = (
  data: TCreateSolutionAPIResponse,
): string | undefined =>
  "solution_slug" in data ? data.solution_slug : data.slug;

export default getSolutionSlugFromCreateResponse;
